import { FormattedNumber } from "react-intl";

const FormattedCurrency = ({ value, notCurrency }) => {
  return (
    <FormattedNumber
      value={value}
      style={notCurrency ? "decimal" : "currency"}
      currency="EUR"
      minimumFractionDigits={0}
      maximumFractionDigits={0}
      useGrouping={true}
      locale="de-DE"
    />
  );
};

export default FormattedCurrency;
